module.exports = __webpack_public_path__ + "static/media/doptelet-pronunciation-speaker-button.28e5b3cf.svg";